// extracted by mini-css-extract-plugin
export default {"root":"root__EtBXlKeEp0LZ","scrollableList":"scrollableList__e3kepOKZl6Jx","returnIcon":"returnIcon__LDjWoBT1OIdC"};